import { useCallback } from 'react';
import { TValidationMethod } from 'js/utils/Validation/types';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as helpers from './helpers';
import { useGetFormFieldValue } from '../../../../hooks';
import { useWithRecordLevelValidation } from '../useWithRecordLevelValidation';

export const usePortugalIdFieldValidation = ({ fieldName }: { fieldName: string }) => {
    const translate = useComponentTranslations();
    const getFormFieldValue = useGetFormFieldValue();
    const withRecordLevelValidation = useWithRecordLevelValidation({ fieldName });

    const portugalIdValidate = useCallback<TValidationMethod<string>>(async (value) => {
        const citizenship = getFormFieldValue('citizenship');

        if (!citizenship) {
            return translate('playtech.mobile.system.form.portugalID.internal.emptyNational');
        }

        if (value.length) {
            return helpers.validateNIF(value)
                ? undefined
                : translate('playtech.mobile.system.form.portugalID.internal.wrong');
        }

        return citizenship === 'PT'
            ? translate('playtech.mobile.system.form.portugalID.internal.portugalIDRequired')
            : undefined;
    }, [getFormFieldValue, translate]);

    return withRecordLevelValidation(portugalIdValidate);
};
